export default __webpack_public_path__ + "static/media/rating.8ed9fa36.svg";